import Vue from "vue";
import VueI18n from "vue-i18n";

import de from "../i18n/de.json";
import en from "../i18n/en.json";
import es from "../i18n/es.json";

import enValidations from "vee-validate/dist/locale/en.json";
import deValidations from "vee-validate/dist/locale/de.json";
import esValidations from "vee-validate/dist/locale/es.json";
Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: window.location.pathname.startsWith("/en")
    ? "en"
    : window.location.pathname.startsWith("/es")
    ? "es"
    : "de",
  messages: {
    de: {
      ...de,
      validations: deValidations.messages,
    },
    en: {
      ...en,
      validations: enValidations.messages,
    },
    es: {
      ...es,
      validations: esValidations.messages,
    },
  },
});
